<template>
  <div>
    <!--   2023 10/19  左边树结构隐藏-->
    <div class="left_tree" v-show="showLeft">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <a-radio-group v-model="type" @change="handleChange">
            <a-radio-button value="dept">
              部门
            </a-radio-button>
            <!--            <a-radio-button value="customer">-->
            <!--              员工-->
            <!--            </a-radio-button>-->
          </a-radio-group>
          <a-button @click="closeAll" style="margin-top: 12px">清空</a-button>
        </div>
        <div class="tree-box" v-if="type === 'dept'">
          <a-tree
              v-model="checkedKeys"
              :show-icon="true"
              checkable
              :expanded-keys="expandedKeys"
              :auto-expand-parent="autoExpandParent"
              :selected-keys="selectedKeys"
              :tree-data="treeData"
              :selectable="false"
              :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
              @expand="onExpand"
              @check="onSelect"
          >
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </div>
        <div class="tree-box" v-if="type === 'customer'">
          <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
                @change="checkedUser"></Tree>
        </div>
      </a-spin>
    </div>
    <!--    <div style="overflow-y: hidden" class="right_table" :class="{showLeft:!showLeft}">-->
    <div class="right_table" :class="{showLeft:!showLeft}">

      <a-icon type="left-circle" style="display: none!important;" class="close" @click="showLeft = false"
              v-if="showLeft"/>
      <a-icon type="right-circle" style="display: none!important;" class="close" @click="showLeft = true" v-else/>
      <div class="report_query_box">
        <div class="item_box" v-if="searchDateRangeShow">
          <span>日期：</span>
          <a-range-picker
              @change="onChangeDate"
              :default-value="dateDefaultDate"
              :format="dateFormat"
              style="width: 350px;"
          />
        </div>

        <div class="item_box">
          <span>品系：</span>
          <a-select
              v-model="search.activityStrain"
              :options="strainOptions"
              style="width: 200px;"
          >
          </a-select>
        </div>

        <div class="item_box">
          <span>经理部：</span>
          <a-select
              v-model="search.regionId"
              :options="regionOptions"
              style="width: 150px;"
              @change="changeRegionId"
          >
          </a-select>
        </div>

        <div class="item_box">
          <span>经销商：</span>
          <a-select
              show-search
              v-model="search.dealerName"
              :options="dealerOptions"
              style="width: 150px;"
          >
          </a-select>
        </div>

        <!--        <div class="item_box">-->
        <!--          <span>类别：</span>-->
        <!--          <a-select-->
        <!--              v-model="search.activityCategory"-->
        <!--              :options="activityCategoryOptions"-->
        <!--              style="width: 150px;"-->
        <!--          >-->
        <!--          </a-select>-->
        <!--        </div>-->

        <!--        <div class="item_box">-->
        <!--          <span>类型：</span>-->
        <!--          <a-select-->
        <!--              v-model="search.activityType"-->
        <!--              :options="activityTypeOptions"-->
        <!--              style="width: 150px;"-->
        <!--          >-->
        <!--          </a-select>-->
        <!--        </div>-->
        <div class="item_box" style="margin-top:6px">
          <!--          <a-row :gutter="24">-->
          <!--            <a-col :span="20">-->
          <span class="spanStyle">类型：</span>
<!--          <a-form-item>-->
<!--            <a-cascader-->
<!--                v-model="search.activityType"-->
<!--                class="cascaderStyle"-->
<!--                placeholder="请选择活动类型"-->
<!--                :options="activityTypeData"-->
<!--                change-on-select-->
<!--                style="width: 200px;"-->
<!--                :fieldNames="{ label: 'typeName', value: 'typeId', children: 'children' }"-->
<!--            />-->
<!--          </a-form-item>-->

          <!--            </a-col>-->
          <!--          </a-row>-->
        </div>
        <!--        <div class="item_box">-->
        <!--          <span>类型：</span>-->
        <!--          <a-input v-model="search.activityTypeName" style="width: 200px;" @keyup.enter.native="searchData" placeholder="请输入类型关键字"/>-->
        <!--        </div>-->
        <!--      <div class="item_box">-->
        <!--        <span>销售顾问：</span>-->
        <!--        <a-input v-model="search.userName" style="width: 150px;" @keyup.enter.native="searchData"/>-->
        <!--      </div>-->

        <div class="item_box">
          <span>车型代码：</span>
          <a-input v-model="search.carNumber" style="width: 200px;" @keyup.enter.native="searchData"
                   placeholder="请输入车型代码"/>
        </div>

        <div class="report_query_btns">
          <a-button class="func_btn_item" type="primary" @click="searchData">筛选</a-button>
          <a-button class="func_btn_item" @click="resetData">重置</a-button>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="exportData('current')">
                <a-icon type="user"/>
                导出当前
              </a-menu-item>
              <a-menu-item key="2" @click="exportData('all')">
                <a-icon type="user"/>
                导出全部
              </a-menu-item>
            </a-menu>
            <a-button class="func_btn_item" type="primary"> 导出
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </div>
      </div>
      <a-table
          :columns="columns"
          :data-source="tableData"
          :pagination="pagination"
          bordered
          :loading="loading"
          size="middle"
          :scroll="{ x: 'calc(700px + 50%)', y: 600 }"
      />
    </div>
  </div>
</template>
<script>
import {formatter as fmt} from "@/utils/ebase-formatter";
import {dataApi} from "@/services/report/report.js";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import XEUtils from "xe-utils";
import moment from 'moment';
//新增的
import Tree from "@/components/picker/Tree";
//新增的
console.log(fmt, loadBaseCodeData)

// 多表头 固定表头
const columns = [
  {
    title: '编号',
    dataIndex: 'activityNo',
    key: 'activityNo',
    width: 110,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '经理部',
    dataIndex: 'regionDeptName',
    key: 'regionDeptName',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '经销商',
    dataIndex: 'dealerDeptName',
    key: 'dealerDeptName',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  // {
  //   title: '类别',
  //   dataIndex: 'activityCategoryName',
  //   key: 'activityCategoryName',
  //   width: 80,
  //   align: 'center',
  // },
  {
    title: '类型',
    dataIndex: 'activityTypeName',
    key: 'activityTypeName',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '活动地点',
    dataIndex: 'activityPlaceName',
    key: 'activityPlaceName',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '品系',
    dataIndex: 'activityStrainName',
    key: 'activityStrainName',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '车型代码',
    dataIndex: 'carNumber',
    key: 'carNumber',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '参加人数',
    dataIndex: 'countSign',
    key: 'countSign',
    width: 80,
    align: 'center',
    className: 'bg-color',
  },
  {
    title: '开展时间',
    className: 'bg-color',
    children: [
      {
        title: '计划',
        dataIndex: 'acitvityPlanDate',
        key: 'acitvityPlanDate',
        width: 100,
        align: 'center',
        className: 'bg-color',
      },
      {
        title: '实际',
        dataIndex: 'acitvityActuralDate',
        key: 'acitvityActuralDate',
        width: 100,
        align: 'center',
        className: 'bg-color',
      },
    ]
  },
  {
    title: '报销情况',
    className: 'bg-color',
    children: [
      {
        title: '实绩费用',
        dataIndex: 'activitySumCharge',
        key: 'activitySumChargereal',
        width: 80,
        align: 'center',
        className: 'bg-color',
      },
      {
        title: '报销费用',
        dataIndex: 'auditCharge',
        key: 'auditCharge',
        width: 80,
        align: 'center',
        className: 'bg-color',
      },
      {
        title: '活动评分',
        dataIndex: 'activityScore',
        key: 'activityScore',
        width: 80,
        align: 'center',
        className: 'bg-color',
      },
    ]
  },
  {
    title: '审批状态',
    className: 'bg-color',
    children: [
      {
        title: '申请状态',
        dataIndex: 'statusName',
        key: 'statusName',
        width: 80,
        align: 'center',
        className: 'bg-color',
      },
      {
        title: '通过时间',
        dataIndex: 'checkDate',
        key: 'checkDate',
        width: 80,
        align: 'center',
        className: 'bg-color',
      },
    ]
  },
];

function activityTypeRule(rule, value, callback) {
  // if(value.length === 1){
  //   callback("一级节点不能选择")
  // }else{
  callback()
  // }
}

function getRulesTemplate() {
  return {
    activityType: {
      rules: [{required: true, message: "请选择活动类型"},
        {validator: activityTypeRule}]
    }
  }
}

export default {
  components: {
    //新增的
    Tree
    //新增的结束
  },
  data() {
    return {
      lastActivityType: '',
      searchDateRangeShow: true,
      dateDefaultDate: [],
      dateFormat: 'YYYY-MM-DD',
      loading: false,
      tableData: [],
      columns,
      // treeDeptData: [],
      regionOptions: [],//经理部
      dealerOptions: [],//经销商
      strainOptions: [],//品系
      //userOptions: [],//销售顾问
      //新增
      // activityCategoryOptions: [],//类别
      // activityTypeOptions: [],//类型
      activityTypeData: [],
      //  新增的
      regionId: '', dealerId: '', deptId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束
      search: {
        page: 1,
        limit: 10,
        startTime: '',
        endTime: '',
        // deptId: 0,
        dealerName: '',// 经销商名字
        // dealerId: '',// 经销商id
        regionId: '',// 经理部id
        activityStrain: '',// 品系id
        //userId: '',// 销售顾问id
        //userName: '',//销售顾问名称搜索
        activityType: 0,//类型id
        activityCategory: '',//类别id
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (page, pageSize) => { //切换页page
          console.log(page);
          console.log(pageSize);
          this.getTableData(page, pageSize);
        },
        showSizeChanger: true,
        onShowSizeChange: (current, size) => { //切换pageSize
          console.log('当前页码', current)
          console.log(size)
          this.getTableData(1, size);
        },
      }
    };
  },
  created() {
    this.handleDefaultDateRange();
  },
  async mounted() {
    this.loadSearchBaseData();
    this.getTableData();
    //新增的开始
    this.init()//一开始就显示树
    //新增的结束
    // this.loadBaseData
  },
  methods: {
    Reset() {
      //sValue 就是目前选中的数组
      this.$refs.cascader.sValue = []
    },
    getRulesTemplate,
    moment,
    handleDefaultDateRange() {
      //日期默认月初 - 到当天
      this.dateDefaultDate = [];
      this.search.startTime = XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd')
      this.search.endTime = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
      this.dateDefaultDate.push(moment(this.search.startTime))
      this.dateDefaultDate.push(moment(this.search.endTime))
    },
    /**
     * 获取多表头表格数据
     * @param currentPage 当前页码 默认1
     * @param pageSize pageSize 默认10
     */
    getTableData(currentPage, pageSize) {
      console.log(this.search.dealerName);
      this.search.page = currentPage ? currentPage : 1;
      this.search.limit = pageSize ? pageSize : 10;
      this.loading = true;
      dataApi.activityListReportData({...this.search}).then(res => {
        console.log('tableData', res)
        this.loading = false;

        let resData = res.data;
        if (!resData.list.length) {
          console.log('暂无数据');
          this.tableData = [];
          this.pagination.total = 0;
          return false;
        }

        if (currentPage) {
          this.pagination.current = currentPage;
        }
        this.pagination.total = resData.totalCount;
        this.pagination.pageSize = resData.pageSize;

        this.tableData = [];
        resData.list.forEach((item, index) => {
          this.tableData.push({
            key: index,

            "activityNo": item.activityNo,//编号
            "regionDeptName": item.regionDeptName,//经理部
            "dealerDeptName": item.dealerDeptName,//经销商
            "activityCategoryName": item.activityCategoryName,//类别
            "activityTypeName": item.activityTypeName,//类型
            "activityPlaceName": item.activityPlaceName,//活动地点
            "activityStrainName": item.activityStrainName,//品系
            "carNumber": item.carNumber,//车型代码
            "countSign": item.countSign,//参加人数
            "acitvityPlanDate": item.acitvityPlanDate,//开展时间-计划
            "acitvityActuralDate": item.acitvityActuralDate,//开展时间-实际
            "activitySumCharge": item.activitySumCharge,//报销情况-实际费用
            "auditCharge": item.auditCharge,//报销情况-报销费用
            "activityScore": item.activityScore,//报销情况-活动评分
            "statusName": item.statusName,//审批状态-申请状态
            "checkDate": item.checkDate,//审批状态-通过时间
            "dealerId": item.dealerId,  //   经销商id
            "regionId": item.regionId, //   经理部id
            "activityStrain": item.activityStrain, //   品系id
            "activityType": item.activityType,//类型id
            "activityCategory": item.activityCategory,//类别id
          })
        })
      });
    },
    //重置
    resetData() {
      this.handleDefaultDateRange();
      //处理更新日期组件不更新问题
      this.searchDateRangeShow = false;
      this.$nextTick(() => {
        this.searchDateRangeShow = true;
      })
      // this.search.dealerId = '';
      this.search.deptId = '';
      this.search.dealerName = '';
      this.search.regionId = '';
      this.search.activityStrain = '';
      this.search.activityType = '';
      this.search.activityCategory = '';
      this.search.carNumber = '';

      this.search = {
        ...this.search,
        'filter.eq.dealerDeptName': '',
        // 'filter.eq.dealerId': '',
        'filter.eq.deptId': '',
        'filter.eq.regionId': '',
        'filter.eq.activityStrain': '',
        'filter.eq.activityType': '',
        'filter.eq.activityCategory': '',
        'filter.like.carNumber': '',

      }
      //新增的
      this.selectedUser = []
      this.checkedKeys = []
      //新增的
      this.getTableData()
    },
    // 搜索
    async searchData() {
      this.lastActivityType = this.search.activityType.length ? this.search.activityType[this.search.activityType.length - 1] : ''

      this.search = {
        ...this.search,
        'filter.eq.dealerDeptName': this.search.dealerName,
        // 'filter.eq.dealerId': this.search.dealerId,
        'filter.eq.deptId': this.search.deptId,
        'filter.eq.regionId': this.search.regionId,
        'filter.eq.activityStrain': this.search.activityStrain,
        'filter.eq.activityType': this.lastActivityType,
        'filter.eq.activityCategory': this.search.activityCategory,
        'filter.like.carNumber': this.search.carNumber,
      }
      this.getTableData()
    },
    //todo 导出
    async exportData(type) {
      this.computedFlag = false
      if (!this.tableData || this.tableData.length <= 0) {
        this.$message.error('当前没有数据可导出')
        return false
      }
      const params = {
        page: this.search.page,
        limit: this.search.limit,
        startTime: this.search.startTime,
        endTime: this.search.endTime,
        dealerId: this.search.dealerId,
        regionId: this.search.regionId,
      }
      await dataApi.exportFile(api.report.REPORTEXPORT + "/queryActivityCountExport?page="
          + this.search.page
          + '&limit=' + this.search.limit
          + '&mode=' + type
          + '&startTime=' + this.search.startTime
          + '&endTime=' + this.search.endTime
          //新增的
          + '&dealerId=' + (type === 'current' ? this.dealerId : '')//this.dealerId
          + '&deptId=' + (type === 'current' ? this.deptId : '')//this.deptId
          + '&regionId=' + (type === 'current' ? this.regionId : '')//this.regionId
          //新增的
          + '&filter.eq.dealerDeptName=' + (type === 'current' ? this.search.dealerName : '')
          + '&filter.eq.regionId=' + (type === 'current' ? this.search.regionId : '')
          + '&filter.eq.activityStrain=' + ((this.search.activityStrain) && (type === 'current') ? this.search.activityStrain : '')
          + '&filter.eq.activityType=' + (this.lastActivityType && (type === 'current') ? this.lastActivityType : '')
          + '&filter.eq.activityCategory=' + ((this.search.activityCategory) && (type === 'current') ? this.search.activityCategory : '')
          + '&filter.like.carNumber=' + ((this.search.carNumber) && (type === 'current') ? this.search.carNumber : '')

          , params).then(blob => {
        this.$message.success('正在导出，请在下载中心下载');
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob.data); //创建下载的链接
        downloadElement.href = href;
        // downloadElement.download = '活动开展列表' + '.xls'; //下载后文件名
        // document.body.appendChild(downloadElement);
        // downloadElement.click(); //点击下载
        // document.body.removeChild(downloadElement); //下载完成移除元素
        // window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {
        console.error('导出失败:' + e);
        this.$message.error('导出失败');
      })
    },
    // 选择日期区间
    onChangeDate(data, dataString) {
      this.search.startTime = dataString[0]
      this.search.endTime = dataString[1]
    },
    // 加载搜索下拉 树等数据
    async loadSearchBaseData() {
      //经理部
      let region = {
        isRegion: 1,
        isDealer: 0
      }
      this.regionOptions = await dataApi.selection(region);//经理部
      // 经理部下拉处理
      this.regionOptions = this.regionOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptId
        }
      })
      this.regionOptions = [{
        value: '',
        label: '全部'
      }].concat(this.regionOptions);

      //经销商
      let dealer = {
        isRegion: 0,
        isDealer: 1
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);

      //品系
      this.strainOptions = await dataApi.selectionStrain();//品系
      this.strainOptions = this.strainOptions.data.map(v => {
        return {
          label: v.strainName,
          value: v.strainId
        }
      })
      this.strainOptions = [{
        value: '',
        label: '全部'
      }].concat(this.strainOptions);

      //类型
      // lxlx
      // this.activityTypeOptions = await dataApi.selectionActivityType()
      // this.activityTypeOptions = this.activityTypeOptions.data.map(v => {
      //   return {
      //     label: v.typeName,
      //     value: v.typeId
      //   }
      // })
      // this.activityTypeOptions = [{
      //   value: '',
      //   label: '全部'
      // }].concat(this.activityTypeOptions);

      let allData = await dataApi.selectionActivityType()
      // this.allActivityTypeData = allData.data;
      this.activityTypeData = XEUtils.toArrayTree(allData.data, {
        key: 'typeId',
        parentKey: 'parentId',
        children: 'children'
      })
      // this.treeData = await loadAreaTreeCasData();
      // dealTreeNoChild(this.treeData)

      //类别
      this.activityCategoryOptions = await loadBaseCodeData('CD400003')
      this.activityCategoryOptions = this.activityCategoryOptions.map(v => {
        return {
          label: v.codeName,
          value: v.codeId
        }
      })
      this.activityCategoryOptions = [{
        value: '',
        label: '全部'
      }].concat(this.activityCategoryOptions);

    },
    //  新增的
    init() {//显示树
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },

    handleChange() {//框如果改变
      this.closeAll()
      this.init()
    },
    closeAll() {//清空已选择的radio选项
      // this.checkedKeys = []
      // this.followUserId = ''
      // this.regionId = ''
      // this.dealerId = ''
      // this.deptId = ''
      // this.search = ''
      //
      // XEUtils.mapTree(this.treeData, item => {
      //   if (item.userList) {
      //     item.userList.map(user => {
      //       user.checked = false
      //     })
      //   }
      //   return item
      // })
      // this.selectedUser = []
      // this.$nextTick(() => {
      // this.refresh()
      this.checkedKeys = []
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      this.selectedUser = []
      // this.search = ''
      this.resetData()
      // })
    },
    //展开列表
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    //筛选开始
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []//做三个数组
      checkedNodes.forEach(item => {
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
          console.log('这是经销商')
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
          console.log('这是经理部')
        } else {
          deptId.push(item.key)
          console.log('这是dept')
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      // this.searchData()
      // {
      // var objActivityType=this.search.activityType
      // var arrActivityType=objActivityType.slice(-1)
      // var lastActivityType=arrActivityType.toString(",")
      this.search = {
        page: this.search.page,
        limit: this.search.limit,
        dealerId: this.dealerId,
        regionId: this.regionId,
        deptId: this.deptId,
        startTime: this.search.startTime,
        endTime: this.search.endTime,
        'filter.eq.activityStrain': (this.search.activityStrain) ? this.search.activityStrain : '',
        'filter.like.activityType': this.lastActivityType ? this.lastActivityType : '',
        'filter.eq.activityCategory': (this.search.activityCategory) ? this.search.activityCategory : '',
        'filter.like.carNumber': (this.search.carNumber) ? this.search.carNumber : '',


      }
      console.log('this.activityType===================================' + this.activityType)
      console.log(this.activityType)
      this.$nextTick(() => {
        this.getTableData();
        console.log('筛出来了')

      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
        console.log('销售顾问1')
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
        console.log('销售顾问2')
      }
      this.userId = this.selectedUser.map(item => {
        console.log('销售顾问3')
        return item.userId
      }).toString()

      this.search = {
        userId: this.userId,
        startTime: this.search.startTime,
        endTime: this.search.endTime,
        page: this.search.page,
        limit: this.search.limit,
        'filter.eq.activityStrain': (this.search.activityStrain) ? this.search.activityStrain : '',
        'filter.like.activityType': this.lastActivityType ? this.lastActivityType : '',
        'filter.eq.activityCategory': (this.search.activityCategory) ? this.search.activityCategory : '',
        'filter.like.carNumber': (this.search.carNumber) ? this.search.carNumber : '',

      }
      this.$nextTick(() => {
        this.getTableData();
        console.log('筛出来了')
      })
    },
    //  新增的结束
    // 2023 10/19监听筛选经理部 联动经销商
    changeRegionId(val){
      this.search.dealerName =''
      this.getDealerData(val)
    },
    /**
     * 2023 10/19经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
    },
  }
};
</script>

<style scoped lang="less">
.report_query_box {
  padding: 30px 12px;
  display: flex;
  flex-wrap: wrap;

  .item_box {
    margin-right: 20px;
    margin-bottom: 12px;
  }

  .func_btn_item {
    margin-left: 12px;
    align-self: flex-end;
  }
}

//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

/deep/ .ant-row, .ant-col {
  margin-left: 44px !important;
  margin-top: -30px !important;
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
